/**
 * The dock row's shared layout (R6.4): ONE line — text, then whatever action the
 * event carries. M1a stacked a 15 px title over a 12 px sub inside an 88 px card;
 * the row is 40 px, so the sub rides INLINE after the title.
 */
import {StyleSheet} from 'react-native';

import {SPACE} from '../../../../theme/tokens';

export default StyleSheet.create({
  rowCard: {
    flex: 1,
    minWidth: 0,
    flexDirection: 'row',
    alignItems: 'center',
    gap: SPACE.sm,
  },
  text: {
    flex: 1,
    minWidth: 0,
    flexDirection: 'row',
    alignItems: 'baseline',
    gap: 6,
  },
});
